import React, { useCallback, useEffect } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import classNames from 'classnames';

import {
  CANCEL_PAUSE_REQUEST_MODAL_STAGES,
  LearnerEmailBadge,
  selectedRequestSelector,
  setCancelRequestModalStage,
  useCancelRequestMutation,
} from 'features/courseResume';
import GlobalLoader from 'components/GlobalLoader';
import styles from './CancelRequestModalConfirmStage.module.scss';

function CancelRequestModalConfirmStage() {
  const dispatch = useDispatch();
  const selectedRequest = useSelector(selectedRequestSelector);
  const { mentee } = selectedRequest;
  const {
    user: { email },
  } = mentee;
  const [cancelRequest, { isSuccess, error, isLoading: isCancelling }] =
    useCancelRequestMutation();

  const handleProceedClick = useCallback(() => {
    if (isCancelling) return;

    cancelRequest({
      requestId: selectedRequest.id,
    });
  }, [cancelRequest, isCancelling, selectedRequest.id]);

  const handleBackClick = useCallback(() => {
    dispatch(
      setCancelRequestModalStage(CANCEL_PAUSE_REQUEST_MODAL_STAGES.notOpen)
    );
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        setCancelRequestModalStage(CANCEL_PAUSE_REQUEST_MODAL_STAGES.success)
      );
      cogoToast.success(
        'Course pause request has been successfully cancelled.'
      );
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in carrying out this action. Please try again later!'
      );
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isCancelling} />
      <div className={styles.root}>
        <Icon
          name="help-new"
          className="h2 m-b-xs"
        />
        <div className="h4 m-b-xs">
          Are you sure you want to cancel this request?
        </div>
        <div className="m-b-m">
          <LearnerEmailBadge email={email} />
        </div>
        <Tappable
          className={classNames('btn', styles.proceedButton)}
          disabled={isCancelling}
          onClick={handleProceedClick}
          noHighlight
        >
          Yes
        </Tappable>
        <Tappable
          className={classNames('btn m-h-xxs', styles.backButton)}
          disabled={isCancelling}
          onClick={handleBackClick}
          noHighlight
        >
          No
        </Tappable>
      </div>
    </>
  );
}

export default CancelRequestModalConfirmStage;
